import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { 
  FaSearch, 
  FaChevronDown,
  FaBars,
  FaTimes,
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn
} from "react-icons/fa";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Authenticate Code", path: "/authenticate" },
    { name: "Contact", path: "/contact" },
  ];

  const dropdownItems = [
    { name: "Injectable", path: "/athligo/injectable", icon: "💉" },
    { name: "Orals Anabolics", path: "/athligo/orals", icon: "💊" },
    { name: "Suplements", path: "/athligo/suplements", icon: "🫙" },
    {/* name: "Sports Nutrition", path: "/athligo/sports-nutritions", icon: "🥤" */},
  ];

  return (
    <div>
      {/* Top Bar */}
      <div className="hidden lg:block bg-gradient-to-r from-gray-900 to-black text-white text-sm py-2">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center gap-6">
          
            <a href="dark@darkdrag.com" className="flex items-center gap-2 hover:text-red-500 transition-colors">
              <FaEnvelope className="text-xs" />
              <span>dark@darkdrag.com</span>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-gray-400">Follow Us:</span>
            {[FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn].map((Icon, i) => (
              <a key={i} href="#" className="hover:text-red-500 transition-colors">
                <Icon className="text-sm" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg py-2' 
          : 'bg-white py-4'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 group">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-red-600 to-amber-600 rounded-lg blur opacity-60 group-hover:opacity-100 transition-opacity"></div>
                <img
                  src="https://darkdraganabolic.in/wp-content/uploads/2023/03/logo.png"
                  alt="Dark Drag Logo"
                  className="relative h-10 lg:h-12 w-auto object-contain"
                />
              </div>
              <span className="hidden lg:block text-xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                Dark Drag
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="px-4 py-2 text-gray-700 hover:text-red-600 font-medium rounded-lg hover:bg-red-50 transition-all duration-300"
                >
                  {link.name}
                </Link>
              ))}

              {/* Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setDropdown(true)}
                onMouseLeave={() => setDropdown(false)}
              >
                <button className="px-4 py-2 text-gray-700 hover:text-red-600 font-medium rounded-lg hover:bg-red-50 transition-all duration-300 flex items-center gap-1">
                  Athligo Series
                  <FaChevronDown className={`text-xs transition-transform duration-300 ${dropdown ? 'rotate-180' : ''}`} />
                </button>

                {dropdown && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden animate-fadeIn">
                    {/* Dropdown Header */}
                    <div className="bg-gradient-to-r from-red-600 to-amber-600 text-white p-4">
                      <h3 className="font-bold">Athligo Series</h3>
                      <p className="text-xs opacity-90">Premium performance products</p>
                    </div>
                    
                    {/* Dropdown Items */}
                    <div className="p-2">
                      {dropdownItems.map((item) => (
                        <Link
                          key={item.path}
                          to={item.path}
                          className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-300 group"
                        >
                          <span className="text-xl">{item.icon}</span>
                          <div>
                            <span className="font-medium">{item.name}</span>
                            <p className="text-xs text-gray-500">View products →</p>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </nav>

            {/* Right Icons - Only Search Remaining */}
            <div className="flex items-center gap-2">
              {/* Search Button */}
              <button
                onClick={() => setSearchOpen(!searchOpen)}
                className="hidden lg:flex w-10 h-10 items-center justify-center text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-full transition-all duration-300"
              >
                <FaSearch />
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-300"
              >
                {isOpen ? <FaTimes className="text-xl" /> : <FaBars className="text-xl" />}
              </button>
            </div>
          </div>

          {/* Search Bar (Expandable) */}
          {searchOpen && (
            <div className="hidden lg:block mt-4 animate-slideDown">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search for products, categories, or brands..."
                  className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-full focus:outline-none focus:border-red-600 focus:ring-2 focus:ring-red-600/20 transition-all text-gray-900 pr-24"
                  autoFocus
                />
                <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-2">
                  <button className="px-4 py-2 bg-gradient-to-r from-red-600 to-amber-600 text-white rounded-full text-sm font-semibold hover:shadow-lg transition-all">
                    Search
                  </button>
                </div>
              </div>
              
              {/* Quick Links */}
              <div className="flex gap-4 mt-3 text-sm">
                <span className="text-gray-500">Popular:</span>
                {["Injectable", "Orals Anabolics", "Sports Nutrition", "Supplements"].map((item) => (
                  <button key={item} className="text-gray-600 hover:text-red-600 transition-colors">
                    {item}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Mobile Menu - Account/Cart/Wishlist Removed */}
        {isOpen && (
          <div className="lg:hidden fixed inset-x-0 top-[72px] bottom-0 bg-white z-50 overflow-y-auto animate-slideIn">
            <div className="p-4 space-y-4">
              {/* Mobile Search */}
              <div className="relative">
                <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search products..."
                  className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-red-600"
                />
              </div>

              {/* Mobile Navigation */}
              <nav className="space-y-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setIsOpen(false)}
                    className="block px-4 py-3 text-gray-700 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-300 font-medium"
                  >
                    {link.name}
                  </Link>
                ))}

                {/* Mobile Dropdown */}
                <div className="border-t border-gray-100 pt-2 mt-2">
                  <p className="px-4 py-2 text-sm font-semibold text-gray-900">Athligo Series</p>
                  {dropdownItems.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={() => setIsOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-300 ml-4"
                    >
                      <span>{item.icon}</span>
                      <span>{item.name}</span>
                    </Link>
                  ))}
                </div>

                {/* Contact Info - Only Contact Info Remains */}
                <div className="border-t border-gray-100 pt-4 mt-4">
                  <p className="text-sm font-semibold text-gray-900 mb-3 px-4">Contact Info</p>
                  <div className="space-y-2 px-4">
                  
                    <a href="mailto:support@darkdraganabolic.net" className="flex items-center gap-3 text-sm text-gray-600 hover:text-red-600">
                      <FaEnvelope className="text-xs" />
                      dark@darkdrag.com
                    </a>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        )}
      </header>
    </div>
  );
};
export default Header;